import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheckCircle, MdHome, MdLightMode, MdLocationPin, MdSearch } from "react-icons/md";
import logo_icon from '../assets/logo_icon.png';
import logo from '../assets/logo.png';
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneObjective from "./OneObjective";

export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								About Us

								<span
									style={{
										display: "block",
										borderBottom: "3px solid var(--secondaryColor)",
										width: "50px",
										marginTop: "10px"
									}}
								>

								</span>
							</h6>
						</div>

						<div className="col-md-6 text-center mb-3 mt-3">
							<div className="card bg-primary">
								<div className="card-body text-center">
                  <img
										src={logo_icon}
										style={{
											width: "80px"
										}}
									/>
                  <br/>
									<img
										src={logo}
										style={{
											width: "250px"
										}}
									/>
								</div>
							</div>
						</div>

						<div className="col-md-6 mt-3 mb-3">
							
              <h6
                className="font-bold"
                style={{
                  fontSize: "24px",
                }}
              >
                HISTORY
              </h6>
							<p
								style={{
									fontSize: "16px"
								}}
							>
								The Tanzania Youth Integrated Development Initiative (TYIDI) was established to address the
                persistent challenges faced by youth engaged in Agriculture value chain. Although formally
                registered in 2025, its foundation was built on years of community engagement, youth
                empowerment initiatives, and informal trader support networks.
                TYIDI officially began its operations in June 2025 with the goal of creating Integrity,
                Inclusiveness, Innovation, Accountability, Sustainability, Youth-led communities
								
							</p>
							
						</div>

            <div className="col-md-12 mt-4 mb-4">
							
              <h6
                className="font-bold"
                style={{
                  fontSize: "24px",
                }}
              >
                WHO WE ARE
              </h6>
							<p
								style={{
									fontSize: "16px"
								}}
							>
								The <span className="font-bold">Tanzania Youth Integrated Development Initiative (TYIDI)</span> is a non-profit, youth-driven
                organization dedicated to empowering youth engaged in sustainable, equitable, youth-based
                development solutions in neglected Tanzanian communities,. TYIDI works to promote inclusive
                economic development by strengthening youth capacities, enhancing access to reliable
                innovation solution, and addressing the structural challenges that limit fair and transparent of
                youths issues.
							</p>

              <p
								style={{
									fontSize: "16px"
								}}
                className="mt-4"
							>
								We collaborate with government agencies, private-sector partners, and community-based
                organizations to reduce youth innovation barriers, expand digital and financial inclusion, and
                create safe, efficient, and good working environments. Our work is grounded in the belief that
                empowered young people are catalysts for sustainable economic transformation across Tanzania
                and the wider East African region.
							</p>
							
						</div>

						

						<div className="col-md-6 bg-primary">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center font-bold mt-5 mb-2"
							>
								OUR VISION
							</h6>

							<h6
								style={{
									fontSize: "16px",
									padding: "20px"
								}}
								className="font-semi-bold"
							>
								To be the leading organization for youths in sustainable, equitable, youth-based development
                solutions in neglected Tanzanian communities, from the ground up.
                We believe that the most effective way to understand socio-economic problems and identify
                solutions is to connect to the source. In this way, youth are invested in the entire process – by
                developing, implementing, monitoring, and sustaining projects and programs over the long-term.
							</h6>
							
						</div>

						<div className="col-md-6 bg-surface">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center font-bold mt-5 mb-2"
							>
								OUR MISSION
							</h6>

							<h6
								style={{
									fontSize: "16px",
									padding: "20px"
								}}
								className="font-semi-bold"
							>
								To find, listen, engage, and provide assistance to support youths in implementing solutions to
                socio-economic problems they have identified. All of our youth projects are developed from the
                ground up, not from the top down. We work with rural youths in Tanzania that are neglected,
                starting with the Tanzania regions.

							</h6>
							
						</div>

            
            <div className="col-md-12 mt-5 mb-4">
							
              <h6
                className="font-bold"
                style={{
                  fontSize: "24px",
                }}
              >
                ORGANIZATIONAL STRUCTURE
              </h6>

              <p
                style={{
                  fontSize: "16px"
                }}
              >
                TYIDI operates under a structured governance and leadership framework to ensure accountability,
                transparency, and effective program delivery. Our organizational structure includes:
              </p>

              <ul
                style={{
                  fontSize: "16px",
                  paddingLeft: "20px"
                }}
              >
                <li className="mb-2">
                  <span className="font-semi-bold">Board of Directors</span> for governance and strategic oversight
                </li>
                <li className="mb-2">
                  <span className="font-semi-bold">Executive Management Team</span> for organizational and strategic leadership
                </li>
                <li className="mb-2">
                  <span className="font-semi-bold">Programmatic Teams</span> comprising youth professionals, community mobilizers,
                  and technical advisors
                </li>
              </ul>

            </div>

            <div className="col-md-12 mt-4 mb-4">
                          
              <h6
                className="font-bold"
                style={{
                  fontSize: "24px",
                }}
              >
                PARTNERSHIPS AND NETWORKS
              </h6>

              <p
                style={{
                  fontSize: "16px"
                }}
              >
                TYIDI believes in the power of collaboration and multi-stakeholder engagement. We work closely
                with a wide range of partners and networks to maximize impact and sustainability, including:
              </p>

              <ul
                style={{
                  fontSize: "16px",
                  paddingLeft: "20px"
                }}
              >
                <li className="mb-2">Local Government Authorities (LGAs)</li>
                <li className="mb-2">Ministries, Departments, and Agencies (MDAs)</li>
                <li className="mb-2">Development partners and donors</li>
                <li className="mb-2">Private sector actors</li>
                <li className="mb-2">Academic and research institutions</li>
                <li className="mb-2">National and regional youth networks</li>
              </ul>

            </div>

            

						<div className="col-md-12">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center font-bold mt-5 mb-2"
							>
								OUR VALUES
							</h6>

							<div className="row">
								<div className="col-md-12">
									<OneObjective
										icon={<MdCheckCircle size={42} className="text-primary"/>}
										content={`Integrity`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<MdCheckCircle size={42} className="text-primary"/>}
										content={`Inclusiveness`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<MdCheckCircle size={42} className="text-primary"/>}
										content={`Innovation`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<MdCheckCircle size={42} className="text-primary"/>}
										content={`Accountability`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<MdCheckCircle size={42} className="text-primary"/>}
										content={`Sustainability`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<MdCheckCircle size={42} className="text-primary"/>}
										content={`Youth-led`}
									/>
								</div>

								

							</div>
							
						</div>

						
						

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}